import React, { useState, useEffect } from 'react';
import { Row, Col, Modal, Button, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import {
    addDivisionAPI,
    editDivisionAPI,
    deleteDivisionAPI,
    getAllDivisionsAPI,
    getAllZonesAPI,
    getAllDivisionsZoneAPI,
    getAllVendorsAPI,
} from '../../../../API/RDPMS_API';
import * as bootstrap from 'bootstrap';
import Table from '../../../../components/Table';
import { addDivisionColumns, sizePerPageList } from '../../../../utils/ColumnUtils';
import { Loading } from 'react-loading-ui';
import { useSelector } from 'react-redux';

const AddDivision = () => {
    const { t } = useTranslation();
    const [limit, setLimit] = useState(5);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [selectedZone, setSelectedZone] = useState('');
    const [data, setData] = useState([]);
    const [zones, setZones] = useState([]);
    const [vendor, setVendor] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [loader, setLoader] = useState(false);
    const [editData, setEditData] = useState(null);
    const [deleteID, setDeleteID] = useState(null);

    useEffect(() => {
        getAllVendorsData();
        getZones();
        getAllDivisionData(limit, pageNumber);
    }, []);

    const { auth } = useSelector((state) => ({
        auth: state.Auth,
    }));

    const getAllVendorsData = async () => {
        try {
            Loading();

            let response = await getAllVendorsAPI();

            if (response && response?.length > 0) {
                setVendor(response);
            }
        } catch (error) {
            console.error('Error vendor data:', error);
            toast.error(t('Failed to refresh vendor data'), {
                position: toast.POSITION.TOP_RIGHT,
            });
        } finally {
            Loading();
        }
    };
    const getZones = async () => {
        try {
            let response = await getAllZonesAPI();

            let zoneList =
                response?.data ||
                response?.message ||
                response?.zones ||
                response?.data?.zones ||
                (Array.isArray(response) ? response : []);

            if (zoneList?.length > 0) {
                setZones(zoneList);
            } else {
                toast.error('No zones returned from API');
            }
        } catch (err) {
            console.error(err);
            toast.error('Failed to load zones');
        }
    };

    const getAllDivisionData = async (limits, pages) => {
        try {
            Loading();

            let limitNumber = limits || limit;
            let pagesNumber = pages || pageNumber;

            let request = {
                limit: limitNumber,
                page: pagesNumber,
            };

            let response = await getAllDivisionsZoneAPI(request);
            // console.log('DIVISION API RAW RESPONSE:', response);

            if (response && response.data && response.data.length > 0) {
                let dataArray = response.data.map((item) => {
                    return {
                        id: item.id,
                        createdDate: moment(item.createdAt).format('Do MMM YYYY, h:mm A'),

                        zoneName: item?.zoneDetails?.zone_name || '-',
                        zoneCode: item?.zoneDetails?.zone_code || '-',
                        zoneId: item?.zoneDetails?.zone_id || '-',

                        divisionName: item.division_name,
                        divisionCode: item.division_code,
                        divisionId: item.division_id,

                        status: item.status,

                        action: (
                            <div className="d-flex justify-content-center align-items-center gap-1">
                                <Link to="#" className="action-icon" onClick={() => openEditModal(item)}>
                                    <i className="mdi mdi-pencil"></i>
                                </Link>

                                <Link
                                    to="#"
                                    className="action-icon text-danger"
                                    onClick={() => openDeleteModal(item.id)}>
                                    <i className="mdi mdi-delete"></i>
                                </Link>
                            </div>
                        ),
                    };
                });

                setPageNumber(response.currentPage);
                setPageCount(response.totalPages);
                setData(dataArray);
                setTotalCount(response.totalCount);

                new bootstrap.Modal(document.getElementById('updateDivisions')).show();
            } else {
                toast.error('No division data found', {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } catch (error) {
            console.error('Error fetching division data:', error);
            toast.error('Failed to refresh division data', {
                position: toast.POSITION.TOP_RIGHT,
            });
        } finally {
            Loading();
        }
    };

    const divisionSchemaResolver = yupResolver(
        yup.object().shape({
            division_name: yup.string().required('Division name is required'),
            division_code: yup.string().required('Division code is required'),
            division_id: yup.string().required('Division ID is required'),
            zone_id: yup.string().required('Zone is required'),
            status: yup.string().required('Please select status'),
        })
    );
    const openModalWithHeaderClass = () => {
        setShowModal(true);
    };
    const closeModalWithHeaderClass = () => {
        setShowModal(false);
        reset();
    };
    const closeEditModal = () => {
        setShowEditModal(false);
        resetEdit();
    };
    const openEditModal = (data) => {
        setEditData(data);
        setShowEditModal(true);
    };
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        resolver: divisionSchemaResolver,
    });

    const {
        register: registerEdit,
        handleSubmit: handleSubmitEdit,
        formState: { errors: errorsEdit },
        reset: resetEdit,
        setValue: setValueEdit,
    } = useForm({
        resolver: divisionSchemaResolver,
    });
    const handlePageChange = async (value) => {
        setPageNumber(1);
        setLimit(value);
        await getAllDivisionData(value, 1);
    };

    const handlePageClick = async (value) => {
        setPageNumber(value);
        await getAllDivisionData(limit, value);
    };
    const openDeleteModal = (id) => {
        setDeleteID(id);
        setShowDeleteModal(true);
    };
    const closeDeleteDivisionModal = () => {
        setShowDeleteModal(false);
        setDeleteID(null);
    };
    useEffect(() => {
        if (showEditModal && editData) {
            setValueEdit('division_name', editData.division_name);
            setValueEdit('division_code', editData.division_code);
            setValueEdit('division_id', editData.division_id);
            setValueEdit('zone_id', editData.zone_id);
            setValueEdit('status', editData.status);
        }
    }, [showEditModal, editData, setValueEdit]);

    const onSubmitAdd = async (formData) => {
        try {
            Loading();

            const selectedZone = zones.find((z) => z.id === formData.zone_id);

            let payload = {
                ...formData,
                zone_name: selectedZone.zone_name,
            };

            let response = await addDivisionAPI(payload);

            if (response) {
                toast.success('Division added successfully');
                getAllDivisionData(limit, pageNumber);
                setShowModal(false);
                reset();
            }
        } catch (err) {
            toast.error('Failed to add division');
        } finally {
            Loading();
        }
    };

    const onSubmitEdit = async (formData) => {
        try {
            Loading();

            formData.id = editData.id;

            const selectedZone = zones.find((z) => z.id === formData.zone_id);

            let payload = {
                ...formData,
                zone_name: selectedZone.zone_name,
            };

            let response = await editDivisionAPI(payload);

            if (response) {
                toast.success('Division updated successfully');
                setShowEditModal(false);
                getAllDivisionData(limit, pageNumber);
            }
        } catch (err) {
            toast.error('Failed to update division');
        } finally {
            Loading();
        }
    };

    const handleDelete = async () => {
        try {
            Loading();
            let response = await deleteDivisionAPI(deleteID);

            if (response) {
                toast.success('Division deleted');
                getAllDivisionData();
            }
        } catch (err) {
            toast.error('Failed to delete');
        } finally {
            setShowDeleteModal(false);
            Loading();
        }
    };

    return (
        <div style={{ width: '100%' }}>
            {/* Page Header */}
            <div className="row">
                <div className="w-100 d-flex justify-content-between">
                    <div className="col-sm-6" style={{ marginLeft: '-2rem' }}>
                        <button className="btn_1">{t('DIVISION')}</button>
                    </div>

                    <div className="col-sm-6 d-flex justify-content-end">
                        <Button className="export text-black" onClick={openModalWithHeaderClass}>
                            {t('ADD DIVISION')} <i className="fas fa-plus"></i>
                        </Button>

                        {/* ONLY ZONE REFRESH */}
                        <button
                            className="update"
                            id="update"
                            type="button"
                            onClick={() => getAllDivisionData(limit, pageNumber)}>
                            {t('Update')} <i className="fas fa-sync-alt"></i>
                        </button>
                    </div>
                </div>
            </div>

            {/* ---------------- Add Division Modal ---------------- */}
            <Modal show={showModal} onHide={closeModalWithHeaderClass} centered>
                <Modal.Header closeButton style={{ backgroundColor: '#D9E9FF' }}>
                    <Modal.Title>{t('Add Division')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form onSubmit={handleSubmit(onSubmitAdd)}>
                        {/* Division Name */}
                        <div className="mb-3">
                            <label className="form-label">{t('Division Name')}</label>
                            <input
                                type="text"
                                className={`form-control ${errors.division_name ? 'is-invalid' : ''}`}
                                placeholder="Enter Division Name"
                                {...register('division_name')}
                            />
                            {errors.division_name && <p className="text-danger">{errors.division_name.message}</p>}
                        </div>

                        {/* Division Code */}
                        <div className="mb-3">
                            <label className="form-label">{t('Division Code')}</label>
                            <input
                                type="text"
                                className={`form-control ${errors.division_code ? 'is-invalid' : ''}`}
                                placeholder="Enter Division Code"
                                {...register('division_code')}
                            />
                            {errors.division_code && <p className="text-danger">{errors.division_code.message}</p>}
                        </div>

                        {/* Division ID */}
                        <div className="mb-3">
                            <label className="form-label">{t('Division ID')}</label>
                            <input
                                type="text"
                                className={`form-control ${errors.division_id ? 'is-invalid' : ''}`}
                                placeholder="Enter Division ID"
                                {...register('division_id')}
                            />
                            {errors.division_id && <p className="text-danger">{errors.division_id.message}</p>}
                        </div>

                        {/* Zone Name */}
                        <div className="mb-3">
                            <label className="form-label">{t('Select Zone')}</label>
                            <select
                                className={`form-select ${errors.zone_id ? 'is-invalid' : ''}`}
                                {...register('zone_id')}
                                onChange={(e) => {
                                    setSelectedZone(e.target.value);
                                    getAllDivisionData(limit, pageNumber, e.target.value);
                                }}>
                                <option value="">{t('Select Zone')}</option>
                                {zones?.map((z) => (
                                    <option key={z.id} value={z.id}>
                                        {z.zone_name}
                                    </option>
                                ))}
                            </select>
                            {errors.zone_id && <p className="text-danger">{errors.zone_id.message}</p>}
                        </div>

                        {/* Status */}
                        <div className="mb-3">
                            <label className="form-label">{t('Status')}</label>
                            <select
                                className={`form-select ${errors.status ? 'is-invalid' : ''}`}
                                {...register('status')}>
                                <option value="">Select Status</option>
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                            {errors.status && <p className="text-danger">{errors.status.message}</p>}
                        </div>

                        {/* Submit */}
                        <div className="d-flex justify-content-end">
                            <button
                                type="submit"
                                className="btn btn-submit"
                                style={{
                                    backgroundColor: '#F9B74C',
                                    width: '200px',
                                    borderRadius: '0%',
                                    border: 'none',
                                }}
                                disabled={loader}>
                                {loader ? (
                                    <>
                                        <Spinner as="span" animation="grow" size="sm" />
                                        Loading
                                    </>
                                ) : (
                                    <>
                                        <i className="mdi mdi-login"></i> {t('Submit')}
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

            <Modal show={showEditModal} onHide={closeEditModal} centered>
                <Modal.Header closeButton style={{ backgroundColor: '#D9E9FF' }}>
                    <Modal.Title>{t('Edit Division')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form onSubmit={handleSubmitEdit(onSubmitEdit)}>
                        <div className="mb-3">
                            <label>{t('Division Name')}</label>
                            <input className="form-control" {...registerEdit('division_name')} />
                            <p className="text-danger">{errorsEdit.division_name?.message}</p>
                        </div>

                        <div className="mb-3">
                            <label>{t('Division Code')}</label>
                            <input className="form-control" {...registerEdit('division_code')} />
                            <p className="text-danger">{errorsEdit.division_code?.message}</p>
                        </div>

                        <div className="mb-3">
                            <label>{t('Division ID')}</label>
                            <input className="form-control" {...registerEdit('division_id')} />
                            <p className="text-danger">{errorsEdit.division_id?.message}</p>
                        </div>

                        <div className="mb-3">
                            <label>{t('Select Zone')}</label>
                            <select className="form-select" {...registerEdit('zone_id')}>
                                <option value="">Select Zone</option>
                                {zones.map((z) => (
                                    <option key={z.id} value={z.id}>
                                        {z.zone_name}
                                    </option>
                                ))}
                            </select>
                            <p className="text-danger">{errorsEdit.zone_id?.message}</p>
                        </div>

                        <div className="mb-3">
                            <label>{t('Status')}</label>
                            <select className="form-select" {...registerEdit('status')}>
                                <option value="">Select Status</option>
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                            </select>
                            <p className="text-danger">{errorsEdit.status?.message}</p>
                        </div>

                        <div className="mb-3">
                            <label>{t('Updated On')}</label>
                            <input
                                type="text"
                                className="form-control"
                                value={moment(editData?.updatedAt).format('Do MMM YYYY, h:mm A')}
                                disabled
                            />
                        </div>

                        <div className="d-flex justify-content-end">
                            <button className="btn btn-warning" type="submit">
                                {t('Update')}
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
            <div className="modal fade" id="updateDivisions" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header close">
                            <button type="button" className="btn-close ms-auto" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body text-center">
                            <img
                                src="/asset-images/checkmark.png"
                                alt="Success"
                                className="img-fluid"
                                style={{ maxWidth: '100px' }}
                            />
                            <p className="mt-3">{t('Divisions data refreshed successfully')}</p>
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={showDeleteModal} onHide={closeDeleteDivisionModal} centered>
                <Modal.Header closeButton style={{ backgroundColor: '#D9E9FF' }}>
                    <Modal.Title>{t('Delete Division')}</Modal.Title>
                </Modal.Header>

                <Modal.Body className="text-center">
                    <img
                        src="/asset-images/deleteiconmodal.png"
                        alt="Delete"
                        className="img-fluid"
                        style={{ maxWidth: '100px' }}
                    />

                    <p className="mt-3">{t('Are you sure you want to delete this division')}?</p>

                    <div className="d-flex justify-content-center gap-2">
                        <Button
                            variant="secondary"
                            onClick={closeDeleteDivisionModal}
                            style={{ width: '100px', borderRadius: '0' }}>
                            No
                        </Button>

                        <Button
                            variant="outline-danger"
                            onClick={handleDelete}
                            style={{
                                width: '100px',
                                borderRadius: '0',
                                border: '2px solid red',
                            }}>
                            Yes
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>

            {/* -------------------------- DIVISION TABLE --------------------------- */}
            <div
                className="col-6 col-sm-6 card-add-station p-3 border-0 text-start no-radius my-2"
                style={{
                    width: '100%',
                    boxShadow: '0px 0px 35px rgba(154, 161, 171, 0.15)',
                }}>
                <div className="station-table-wrapper">
                    <Table
                        columns={addDivisionColumns(t)}
                        data={data}
                        pageSize={limit}
                        pageCount={pageCount}
                        pageNumber={pageNumber}
                        totalCount={totalCount}
                        sizePerPageList={sizePerPageList}
                        isSortable={true}
                        pagination={true}
                        isSearchable={true}
                        onPageChange={handlePageChange}
                        onPageClick={handlePageClick}
                    />
                </div>
            </div>
        </div>
    );
};

export default AddDivision;
